var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr',{staticClass:"m-0 border-light"}),_c('Header'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }